import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import botnet from "../../Assets/Projects/botnet.jpg";
import malabsi from "../../Assets/Projects/malabsi.png";
import sohargate from "../../Assets/Projects/sohargate.png";
import aus from "../../Assets/Projects/AUS.png";
import gwp from "../../Assets/Projects/gwp7.png";
import comingsoon from "../../Assets/Projects/comingsoon.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={botnet}
              isBlog={false}
              title="Botnet Attack Detection using Machine Learning"
              description="Using the Bot-IoT and University of New South Wales (UNSW) datasets, four machine learning models based on four classifiers are built: Naïve Bayes, K-Nearest Neighbor, Support Vector Machine, and Decision Trees. Using 82,000 records from UNSW-NB15 dataset, the decision trees model has yielded the best overall results with 99.89% testing accuracy in detecting botnet attacks."
              link="https://ieeexplore.ieee.org/abstract/document/9299061"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={malabsi}
              isBlog={false}
              title="Malabsi Fashion"
              description="An Online English-Arabic language e-commerce serverless platform for fashion store made using ReactJS, Material UI and bootstrap for front-end and AWS microservices as well as Graph QL for the back-end. Whilst encorporating and intergrating Mashreq Bank payment gateway as an online payment method."
              link="https://github.com/walshamkhany"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sohargate}
              isBlog={false}
              title="Sohar Gate"
              description="Solo Designed, Developed and Lunched a one page site for a start-up business retailers Sohar Gate whom work in the Oil Field industry and commercial services. Using Bootstrap 4, Javascript and pure HTML. "
              link="https://sohargate.com/"
            />
          </Col>
           <Col md={4} className="project-card">
            <ProjectCard
              imgPath={aus}
              isBlog={false}
              title="Arabian Gulf Monitor System"
              description="Intern Developed a system, useful to those who are interested in NASA Ocean Color products for the Arabian Gulf including environmental agencies,fishery industry, scientists, students ,etc.. "
              link="  https://www.aus.edu/apps/agms"
            />
          </Col>
        
            <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gwp}
              isBlog={false}
              title="Golden Well Petro"
              description="First project Solo Designed, Developed and Lunched one page site for a start-up business retailers Golden Well Petro whom work in the Oil Field industry and commercial services. Using Bootstrap 4, Javascript and pure HTML. "
              link="https://goldenwellpetro.com/"
            />
          </Col>
        </Row>
        <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs</p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={comingsoon}
              link=""
              title=""
              site=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
